/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Login from './Login';
import { setBackUrl } from '../../../actions/login'


const title = '登录-有道精品课';

async function action({ query, store }) {
  let { back_url: backUrl = '/?loginBack=true' } = query

  let decodeBackurl = decodeURIComponent(backUrl)

  if (!/loginBack=true/.test(backUrl)) {
    backUrl += backUrl.indexOf('?') === -1 ? '?' : '&'
    backUrl += 'loginBack=true'
  }

  if (/loginBack=false/.test(decodeBackurl)) {
    backUrl.replace('loginBack=false', 'loginBack=true')
  }

  // 验证url有效性, http开头但非有道网易域名，或包含脚本标签，跳转到首页
  if (
    (/^https?:/.test(decodeBackurl) && !(/^http[s]?:\/\/[^/]*\.(163|youdao|ydstatic|126|huihui)\.com(:\d{2,4})?\//.test(decodeBackurl))) ||
    /javascript:/i.test(decodeBackurl)
  ) {
    decodeBackurl = '/?loginBack=true'
  }

  await store.dispatch(setBackUrl(decodeBackurl))


  return {
    chunks: ['login'],
    component: <Login title={title} />,
    title,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/login/login/index.js